export class Customer {
    constructor(customer){
        const props = Object.assign({}, customerModel, customer, {})
        Object.entries(props).forEach(([key, value]) => {
            this[key] = value
        })
    }
}

export const customerModel = {
    name: '',
    description: ''
}